import React, { useState } from 'react';
import { ListBase, ListProps } from 'react-admin';
import { useLocation } from 'react-router-dom';
import { isLegacyPin, useLinkedPin } from '../Common/DataList';
import ChangeInstancesListPage from '../ChangeInstances/List/ChangeInstancesListPage';
import { ChangeInstancesListConfig } from '../ChangeInstances/List/types';
import ChangeInstanceRow from './ChangeInstanceRow';

const config: ChangeInstancesListConfig = {
    resource: 'owner_change_instances',
    serviceItemPath: '/owner_service_items',
    applicationsResource: 'owner_applications',
    serviceItemsResource: 'owner_service_items',
    servicesResource: 'services',
    teamsResource: 'consumer_teams',
    partyField: {
        label: 'Consumer Team',
        team: (record) => record.consumer_team,
        pov: 'consumer',
    },
    // owners approve / reject / complete from the panel, so it must be able to
    // refresh the list once the state changes
    ExpandedRow: ChangeInstanceRow,
    expandedRowNeedsRefresh: true,
};

const ChangeList = (props: ListProps) => {
    // Same ?id= filter as the consumer list — see ChangeInstances/ChangeList.
    const location = useLocation();
    const [pinnedId] = useState(() => {
        const id = new URLSearchParams(location.search).get('id');
        return isLegacyPin(id) ? null : id;
    });
    // a link to a change (#123) puts it first — see the consumer list
    const pin = useLinkedPin();

    return (
        <ListBase
            // a new link is a new list — see useLinkedPin
            key={pin.pin ?? ''}
            sort={{ field: 'id', order: 'DESC' }}
            filter={pinnedId ? { light: true, id: pinnedId, ...pin } : { light: true, ...pin }}
            perPage={25}
            filterDefaultValues={pinnedId ? undefined : { state: 'PENDING,APPROVED' }}
            {...props}
        >
            <ChangeInstancesListPage config={config} />
        </ListBase>
    );
};

export default ChangeList;
